import { Injectable } from '@angular/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Observable } from 'rxjs';
import {Hort360GrowerProperty, Hort360PropertySummary} from "../../../functions/src/types";

export enum GoogleEvents {
  LoginAttempt = 'LoginAttempt',
  LoginPage = 'LoginPage',
  SearchAccounts = 'SearchAccounts'
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private apiRequest: (data: any) => Observable<any>;

  constructor(
      private recaptchaV3Service: ReCaptchaV3Service,
      private angularFireFunctions: AngularFireFunctions
  ) {
    this.apiRequest = this.angularFireFunctions.httpsCallable('api');
  }

  async loginUser(username: string, password: string, token: string = null): Promise<string> {
    try {
      const recaptcha = await this.getGoogleToken(GoogleEvents.LoginAttempt);
      const login = await this.apiRequest({recaptcha, username, password, token, api: 'authenticate'}).toPromise();
      return login;
    } catch (e) {
      throw new Error(e.message ? e.message : e);
    }
  }

  async seekPropertyIds(keyword: string): Promise<number[]> {
    try {
      const recaptcha = await this.getGoogleToken(GoogleEvents.SearchAccounts);
      const propertyIds: number[] = await this.apiRequest({recaptcha, keyword, api: 'search'}).toPromise();
      return propertyIds;
    } catch (e) {
      throw new Error(e.message ? e.message : e);
    }
  }

  async syncHort360(): Promise<any[]> {
    try {
      const recaptcha = await this.getGoogleToken(GoogleEvents.SearchAccounts);
      return await this.apiRequest({recaptcha, api: 'sync'}).toPromise();
    } catch (e) {
      throw new Error(e.message ? e.message : e);
    }
  }

  async getGoogleToken(eventType: GoogleEvents) {
    try {
      return await this.recaptchaV3Service.execute(eventType).toPromise();
    } catch (e) {
      console.error(e);
    }
    return '03AGdBq26ioIBcyfPdU955AYMrPu_EJZN9o_sD5zAvqJSpC4Ta7illbFeuJKjqfo-59mzFF5onIHsOre39KW-rW298DVgKs225-Mdafc_CQBR7UBIguxtcPlMJRfMcAU28UDLa2PUNbCBRkAdINMby-6jy2TY9J_7K3fXwcliOInUlvZEZahyFYMXqrSy25Vs8gy9mhb66qPk5NPzA-AG2KgkdpnwWXzh4zWr6Cpu89vYxrP2IzZmT0a7RIuJPED9_Dm8snQqC7FQmS-Z6O65IUxzSOMLU7ZwXkhpV7c6BSwNo8Evb1g8fcxx5qbOuoe7wt2t_FeGnlZqMZd8ErSBix-sjTxG2eEP9glHqINzR2WeP2PpK6lSMtDCNbDLxr7yTSAEKVltsdjVW55cTFFZawYSwsVi5Cat-eK8quVKBk0fVWE_mPo_nbkgxYNjaz6IwBSo6FJldxksw'; // TODO: FIX TIMOUT ERROR IN LIB?
  }

  logGoogleEvent(eventType: GoogleEvents) {
    this.getGoogleToken(eventType).then(() => {}, () => {}).catch(() => {});
  }

}
